import chat from '@shared/state/chat';
import { combineReducers, Reducer } from 'redux';
import appInstall from './appInstall';
import appVersion from './appVersion';
import careerGoals from './careerGoals';
import customCategoryGoals from './customCategoryGoals';
import dataState from './dataState';
import experiences from './experiences';
import experienceSkills from './experienceSkills';
import help from './help';
import notifications from './notifications';
import profile from './profile';
import recommendedSkills from './recommendedSkills';
import storeService, { STORE_LOADED } from './storeService';
import tours from './tours';
import user, { USER_FETCHED, USER_LOGGED_OUT } from './user';
import userDocuments from './userDocuments';
import userEvents from './userEvents';
import userLanguages from './userLanguages';

const appReducer = combineReducers({
  user,
  profile,
  userLanguages,
  userDocuments,
  experiences,
  experienceSkills,
  recommendedSkills,
  storeService,
  careerGoals,
  help,
  tours,
  appInstall,
  appVersion,
  notifications,
  dataState,
  userEvents,
  customCategoryGoals,
  chat,
});

type State = typeof appReducer extends Reducer<infer State, any, any> ? State : never;
type Action = typeof appReducer extends Reducer<any, infer Action, any> ? Action : never;

// preserve some store values after logout
const resetState = (state: State) => {
  const { storeService, user } = state;
  return {
    storeService,
    user: { locale: user.locale },
  } as State;
};

const rootReducer = (state: State | undefined, action: Action) => {
  if (!state) {
    return appReducer(state, action);
  }
  if (action.type === STORE_LOADED) {
    return appReducer(action.data as State, action);
  }
  const clearState =
    action.type === USER_LOGGED_OUT ||
    (action.type === USER_FETCHED && state.user.id && !action.data.id);
  return appReducer(clearState ? resetState(state) : state, action);
};

export default rootReducer;
